module.exports = __webpack_public_path__ + "img/consult_info1.9639d957.png";